import { render, staticRenderFns } from "./Wpas.vue?vue&type=template&id=171a9a93"
import script from "./Wpas.vue?vue&type=script&lang=js"
export * from "./Wpas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports